module.exports = "assets/img/loader.gif";